import { render, staticRenderFns } from "./AffiliatesPayments.vue?vue&type=template&id=52bca872&"
import script from "./AffiliatesPayments.vue?vue&type=script&lang=js&"
export * from "./AffiliatesPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52bca872')) {
      api.createRecord('52bca872', component.options)
    } else {
      api.reload('52bca872', component.options)
    }
    module.hot.accept("./AffiliatesPayments.vue?vue&type=template&id=52bca872&", function () {
      api.rerender('52bca872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/affiliates/AffiliatesPayments.vue"
export default component.exports